module.exports = __webpack_public_path__ + "static/project-7d-1c75399b877aed6249a63e1aedff1244.png";